import React from 'react';
import { ContentWrapper } from '../styles';
import { DetailsCardSkeleton } from '../../../../shared/DetailsCard';

const OrderDetailsPanelSkeleton: React.FC = () => (
  <ContentWrapper data-cy="order-details-content">
    <DetailsCardSkeleton variant="status" announce={false} />
    <DetailsCardSkeleton variant="title" announce={false} />
    <DetailsCardSkeleton variant="title" announce={false} />
  </ContentWrapper>
);

export default OrderDetailsPanelSkeleton;
